import { Alert, AlertTitle } from '@mui/material';
import { GridOverlay } from '@mui/x-data-grid-premium';
import { useTranslation } from 'react-i18next';

export interface IGridErrorOverlayProps {
    error?: any;
}

function GridErrorOverlay(props : IGridErrorOverlayProps) {
    const { t } = useTranslation();

    return (
        <GridOverlay>
            <Alert severity="error">
                <AlertTitle>{t('Oops!')}</AlertTitle>
                <p>{t('Sorry, an unexpected error has occurred.')}</p>
                <i>{props.error}</i>
            </Alert>
        </GridOverlay>
    );
}

export default GridErrorOverlay;
